import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AjustageConductivite } from 'src/app/domain/Shared/ajustage-conductivite';
import { AjustageContexte } from 'src/app/domain/Shared/ajustage-context';
import { ControleConductiviteGroup } from 'src/app/domain/Shared/controle-conductivite-groupe';
import { EConductivite } from 'src/app/domain/Shared/enum/conductivite';
import { MasterSondeService } from 'src/app/services/master-sonde.service';

@Component({
    selector: 'app-conductivite-calibration-box',
    templateUrl: './conductivite-calibration-box.component.html',
    styleUrls: ['./conductivite-calibration-box.component.scss']
})
export class ConductiviteCalibrationBoxComponent implements OnInit {

    model: AjustageContexte = new AjustageContexte()
    group: ControleConductiviteGroup = new ControleConductiviteGroup()

    Ajustage1413 = new AjustageConductivite()
    Ajustage84 = new AjustageConductivite()
    Ajustage0 = new AjustageConductivite()
    public interventionTime;
    private sondeRef: string

    CanEditAjustage: boolean = true;

    constructor(
        public dialogRef: MatDialogRef<ConductiviteCalibrationBoxComponent>,
        private sondeService: MasterSondeService,
        @Inject(MAT_DIALOG_DATA) public data) {
        if (data) {
            this.sondeRef = data;
        }

    }

    ngOnInit(): void {

        this.group.C1413.Type = EConductivite.C1413
        this.group.C84.Type = EConductivite.C84

        this.Ajustage1413.ControleConductivite.Type = EConductivite.C1413
        this.Ajustage84.ControleConductivite.Type = EConductivite.C84
        this.Ajustage0.ControleConductivite.Type = EConductivite.C0
        this.getSondeDetails(this.sondeRef)

    }

    timeSet(event: string) {
        const time = event.split(':');

        this.model.Date = new Date(this.model.Date);
        this.model.Date.setHours(Number(time[0]), Number(time[1]));
        this.setTime();
    }

    setTime() {
        this.interventionTime = `${this.model.Date.getHours()}:${this.model.Date.getMinutes()}`;
    }

    CanAddNewMeasure() {
        return this.CanEditAjustage ? 
        this.Ajustage1413.NumeroLot && this.Ajustage1413.DateOuverture &&
        this.Ajustage84.NumeroLot && this.Ajustage84.DateOuverture &&

        this.Ajustage1413.ControleConductivite.Temperature && this.Ajustage1413.ControleConductivite.ValeurCible !== null && this.Ajustage1413.ControleConductivite.ValeurMesuree !== null &&
        this.Ajustage84.ControleConductivite.Temperature && this.Ajustage84.ControleConductivite.ValeurCible !== null && this.Ajustage84.ControleConductivite.ValeurMesuree !== null
        :
        this.group.Date &&
            this.group.C1413.Temperature && this.group.C1413.ValeurCible && this.group.C1413.ValeurMesuree &&
            this.group.C84.Temperature && this.group.C84.ValeurCible && this.group.C84.ValeurMesuree
    }

    getSondeDetails(ref: string) {
        this.sondeService.getSondeByReference(ref).subscribe(x => {
            this.model = x.AjustageContexteList[0] ?? new AjustageContexte();

            if (x.AjustageContexteList[0].Code)
                this.CanEditAjustage = false;
            this.Ajustage1413 = this.model.AjustageConductiviteList.find(x => x.ControleConductivite.Type === EConductivite.C1413) ?? new AjustageConductivite()
            this.Ajustage84 = this.model.AjustageConductiviteList.find(x => x.ControleConductivite.Type === EConductivite.C84) ?? new AjustageConductivite()
            this.Ajustage0 = this.model.AjustageConductiviteList.find(x => x.ControleConductivite.Type === EConductivite.C0) ?? new AjustageConductivite()

            this.Ajustage1413.ControleConductivite.Type = EConductivite.C1413
            this.Ajustage84.ControleConductivite.Type = EConductivite.C84
            this.Ajustage0.ControleConductivite.Type = EConductivite.C0
        })
    }

    checkConformiteA5pourcent(reference: number, value: number) {
        const lowerBound = 0.95 * reference;
        const upperBound = 1.05 * reference;
        return value >= lowerBound && value <= upperBound;
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        this.model.ControleConductiviteGroupeList.push(this.group)

        this.model.AjustageConductiviteList = []
        this.model.AjustageConductiviteList.push(this.Ajustage1413, this.Ajustage84, this.Ajustage0)

        this.dialogRef.close(this.model);
    }
}
